import { IDataFileVisitor } from './IDataFileVisitor.js';
import { RecordKind } from '../../record.js';
import { appendTextToError } from '../../errors/appendTextToError.js';


export class DataFile {
  constructor(private readonly doc: Doc) {}

  accept(visitor: IDataFileVisitor): void {
    if (this.doc && this.doc.kind) {
      switch (this.doc.kind) {
        case RecordKind.Option: {
          visitor.visitOption(this.doc);
          break;
        }
        case RecordKind.OptionGroup: {
          visitor.visitOptionGroup(this.doc);
          break;
        }
        case RecordKind.Product: {
          try {
            visitor.visitProduct(this.doc);
          } catch (error) {
            throw appendTextToError(error, `Invalid situation in ${this.doc.kind} with id "${this.doc._id}"\n`);
          }
          break;
        }
        case RecordKind.ProductGroup: {
          visitor.visitProductGroup(this.doc);
          break;
        }
        case RecordKind.OclConstraint: {
          visitor.visitOclConstraint(this.doc);
          break;
        }
        case RecordKind.OclFilter: {
          visitor.visitOclFilter(this.doc);
          break;
        }
        case RecordKind.JsFilter: {
          visitor.visitJsFilter(this.doc);
          break;
        }
        case RecordKind.ExternalField: {
          visitor.visitExternalFiled(this.doc);
          break;
        }
        case RecordKind.CompatibilityTable: {
          visitor.visitCompatibilityTable(this.doc);
          break;
        }
        default:
          console.log('Doc kind is not defined : ' + this.doc.kind)
      }
    }
  }
}

export type Doc = any;
export type Dataset = Doc[];
export type DocOption = any;
export type DocOptionGroup = any;
export type DocProduct = any;
export type DocProductGroup = any;
export type DocOclConstraint = any;
export type DocOclFilter = any;
export type DocJsFilter = any;
export type DocExternalField = any;
export type DocCompatibilityTable = any;
